import { RouteRecordRaw } from 'vue-router';

const bugReportRoutes: RouteRecordRaw[] = [
   {
      path: '/bug-report',
      name: 'bug-report',
      component: () => import('@/modules/bugReport/pages/Index.vue'),
   },
];

export default bugReportRoutes;
